export const arrow = (
  <svg
    width={21}
    height={17}
    viewBox="0 0 21 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M0.15625 8.87443C0.15625 8.55621 0.285253 8.25101 0.51488 8.02599C0.744506 7.80097 1.05595 7.67455 1.38069 7.67455L15.7262 7.67455L10.3599 2.96943C10.12 2.75671 9.9758 2.45961 9.95874 2.14303C9.94169 1.82645 10.0532 1.51612 10.2688 1.27983C10.4845 1.04354 10.7869 0.900496 11.1098 0.881942C11.4328 0.863387 11.7501 0.970832 11.9925 1.1808L19.7472 7.98012C19.8759 8.09268 19.9788 8.2306 20.0493 8.38486C20.1198 8.53911 20.1562 8.70622 20.1562 8.87523C20.1562 9.04425 20.1198 9.21136 20.0493 9.36561C19.9788 9.51987 19.8759 9.65779 19.7472 9.77035L11.9925 16.5697C11.8728 16.6758 11.7329 16.7577 11.5808 16.8106C11.4287 16.8636 11.2675 16.8866 11.1063 16.8782C10.9451 16.8699 10.7872 16.8304 10.6417 16.762C10.4962 16.6937 10.3658 16.5978 10.2582 16.4799C10.1506 16.3621 10.0679 16.2245 10.0147 16.0752C9.96159 15.9258 9.93908 15.7677 9.94853 15.6098C9.95798 15.4519 9.99918 15.2974 10.0698 15.1552C10.1404 15.0129 10.239 14.8858 10.3599 14.781L15.7262 10.0743L1.38069 10.0743C1.05595 10.0743 0.744506 9.9479 0.51488 9.72288C0.285253 9.49786 0.15625 9.19266 0.15625 8.87443Z"
      fill="#000"
    />
  </svg>
);
